import {
    InterviewType,
    InterviewTypeApiName,
    INTERVIEW_TYPES_BY_API_NAME,
} from '../../../common/interview-type';
import {
  ISessionAction,
} from './actions';

import {
  WS_CONNECTED_ELSEWHERE,
  WS_CURRENT_STATE,
  WS_LANGUAGE,
  WS_CLEAR,
} from '../web-socket/constants';

export type SessionChallengeItemType = 'html' | 'md';

export interface ISessionChallengeItem {
  title: string;
  content: string;
  type?: SessionChallengeItemType;
}

export interface ISessionChallenge {
  challenge: Array<ISessionChallengeItem>;
}

export interface ISessionCodeItem {
  language: string;
  initial: string;
  hasTests?: boolean;
}

export interface ISessionCode {
  code: ISessionCodeItem;
}

export interface ISessionState extends ISessionChallenge, ISessionCode {
    challengeId: string;
    dashboardUrl: string;
    hadLanguageChanged: boolean;
    hadQuestionChanged: boolean;
    hadTestsUnlocked: boolean;
    interviewId: string;
    interviewType: InterviewType;
    intervieweeUserId: string;
    isInterviewer: boolean;
    isQuestionNew: boolean;
    peerFirstName: string;
    rootPath: string;
    showConsoleScrollHint: boolean;
    showRunCodeHint: boolean;
    showVideoHint: boolean;
    startTime: Date;
    token: string;
    videoRoom: string;
}

const initialState: ISessionState = {
    challenge: [],
    challengeId: '',
    code: {
        language: '',
        initial: '',
        hasTests: false,
    },
    dashboardUrl: '',
    hadLanguageChanged: false,
    hadTestsUnlocked: false,
    hadQuestionChanged: false,
    interviewId: '',
    interviewType: INTERVIEW_TYPES_BY_API_NAME.get(InterviewTypeApiName.Algorithms),
    intervieweeUserId: '',
    isInterviewer: false,
    isQuestionNew: false,
    peerFirstName: '',
    rootPath: '',
    showConsoleScrollHint: false,
    showRunCodeHint: false,
    showVideoHint: false,
    startTime: null,
    token: '',
    videoRoom: '',
};

export default function sessionReducer(
  state: ISessionState = initialState,
  action: ISessionAction,
): ISessionState {
  const {type, payload} = action;

  switch (type) {

    case WS_CONNECTED_ELSEWHERE:
      return initialState;

    case WS_CURRENT_STATE:
      return {
        ...state,
        ...payload,
        startTime: new Date(payload.startTime),
        interviewType: INTERVIEW_TYPES_BY_API_NAME.get(payload.interviewType),
      };

    case WS_CLEAR:
      return state.showRunCodeHint
        ? {...state, showRunCodeHint: false}
        : state;

    case WS_LANGUAGE:
      return {...state, code: {...state.code, ...payload}};

    default:
      return state;
  }
}
